import { init } from '@shieldpay/wheeljack/react-router/entry.client.tsx';

init();
